import { createFileRoute } from '@tanstack/react-router';

import LaboratoryDetails from '@/ui/pages/LaboratoryDetails/LaboratoryDetails';

export const Route = createFileRoute('/_dashboard/laboratories/$id/')({
  component: LaboratoryDetails,
});
